import React, { useEffect, useState } from "react";
import { Layout, Space, Input, PageHeader, Select, Button, message,Card, Row, Col } from "antd";
import { useSelector } from "react-redux";
import R2Footer from "../../../../components/Footer";
import EmployeeService from "../../../../services/EmployeeService";
import Dragger from 'antd/lib/upload/Dragger';
import TestimonialService from "../../../../services/TestimonialService";
import { UploadOutlined } from '@ant-design/icons';
// import "./Employee.scss"
import back from '../../../../assets/images/back_arrow.png';


const { Content } = Layout;
const { Option } = Select;

const AddEditEmployee = (props) => {
  const { setViewPage, record, setEditId, getAllUsers } = props;
  const adminRestaurant = useSelector((state) => state.admin)
  const [state, setState] = useState({});
  const [previewFile, setPreviewFile] = useState();
  const [file, setFile] = useState("");
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  const employeeId = record?.id;
  const getCustomizationList = async() => {
    const res = await EmployeeService.getEmployeType(adminRestaurant);
    setDataList(res);
  }

  useEffect(() => {
    if (employeeId) {
      EmployeeService.getEmployeeById(employeeId).then(res => {
        const filterByRes= res.restaurant_roles.find(item => item.restaurant_id == adminRestaurant)
        if (res.id) {
          setState({
            employee_code: filterByRes?.employee_code,
            name: res.name,
            phoneNumber: res.phone_number,
            email: res.email,
            employee_type_id: filterByRes?.employee_type_id,
          })
          if(res.photo_url)
          {
            setPreviewFile(res.photo_url)
            setFile(res.photo_url);
          }
        }
      })
    }
    getCustomizationList();
  }, [])
  

  const handleChange = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const submitFile = async(info) => {
    const formData = new FormData();
        formData.append('file', info.file.originFileObj);
        setLoading(true)
        const  data  = await TestimonialService.uploadPhoto(formData);   
        if(data){
          setPreviewFile(data.url)
          setFile(data.url);
        }
        setLoading(false)
}
  const handleSubmit = async (e) => {
    // e.preventDefault();
    try {
      if(employeeId)
      {
        const res = await EmployeeService.updateEmployee({
          email: state.email,
          name: state.name,
          phone_number: state.phoneNumber,
          restaurant_ids: [adminRestaurant],
          employee_type_id: state.employee_type_id,
          // job_title: state.jobTitle || "",
          employee_code: state.employee_code,
          allow_delivery: true,
          photo_url : file
        },employeeId);
        if(res.id) {
          message.success('Employee Updated successfully');
          // history.push('/business/employees');
          getAllUsers();
          setEditId('');
          setViewPage('');
        }
      }
      else{
      const res = await EmployeeService.createEmployee({
        email: state.email,
        name: state.name,
        phone_number: state.phoneNumber,
        restaurant_ids: [adminRestaurant],
        employee_type_id: state.employee_type_id,
        employee_code: state.employee_code,
        // job_title: state.jobTitle || "",
        allow_delivery: true,
        photo_url : file
      });
      if(res?.id) {
        message.success('Employee created successfully');
        getAllUsers();
        setEditId('');
        setViewPage('');
        // history.push('/business/employees');
      }
      if(res?.err)
        message.error(res?.msg)
    }
    } catch (error) {
      console.log(error)
      message.error('Error creating employee. Please check your input and try again.');
    }
  };

  return (
    <Layout className="u-page-layout add-edit-employee-page">
      <Content className="w-full">
        <Space className="w-full" direction="vertical">
          <PageHeader title={employeeId ? 
            <div><img src={back} alt="" onClick={()=>{setViewPage('all'); setEditId('')}}/> Edit Employee </div>  :
            <div><img src={back} alt="" onClick={()=> setViewPage('all')}/> Add New Employee </div>
           } 
           />
          <Card className="add-employee-card">
            <Row gutter={[16,16]}>
            <Col className="d-flex">
            <div>
           
       {previewFile ? 
       <div className="preview-file"> <img src={previewFile} alt="profile" className="preview-img"/> 
        <Button onClick={()=>setPreviewFile()}>Change Profile pic</Button>
       </div>
       :
         <Dragger onChange={submitFile}  maxCount={1} style={{marginBottom:"10px"}}>
            <p className="ant-upload-drag-icon"><UploadOutlined /></p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
        </Dragger>
}
            </div>
            </Col>
            <Col>
          <form
            className="site-layout-background text-left p-1"
            // onSubmit={()=>handleSubmit()}
          >
            <div className="mb-1">
              <label>Name</label>
              <Input
                placeholder="Name"
                name="name"
                value={state.name}
                onChange={(e) => {
                  handleChange("name", e.target.value);
                }}
              />
            </div>
            <div className="mb-1">
              <label>Email</label>
              <Input
                placeholder="Email"
                name="name"
                value={state.email}
                onChange={(e) => {
                  handleChange("email", e.target.value);
                }}
              />
            </div>
            <div className="mb-1">
              <label className="d-block">Employee Type</label>
              <Select
                value={state.employee_type_id }
                className="w-full"
                placeholder="Employee Type"
                onChange={v => handleChange('employee_type_id', v)}
              >
                {dataList?.map((itm)=> <Option key={itm.id} value={itm.id}>{itm.name}</Option>)}
              </Select>
            </div>
            <div className="d-flex w-full mb-1" style={{ flexWrap: "wrap" }}>
              <div className="flex-1">
                <label>Phone Number</label>
                <Input
                  placeholder="Phone Number"
                  name="PhoneNumber"
                  autoComplete="tel"
                  type="number"
                  value={state.phoneNumber}
                  onChange={(e) => {
                    handleChange("phoneNumber", e.target.value);
                  }}
                />
              </div>
              <div className="flex-1 ml-1">
                <label>Employee Code</label>
                <Input
                  placeholder="employee_code"
                  name=""
                  value={state.employee_code}
                  onChange={(e) => {
                    handleChange("employee_code", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="submit-btn">
            <Button className="mt-1" type="primary" onClick={()=>handleSubmit()}>
              Save
            </Button>
            </div>
           
          </form>
          </Col>
          </Row>
          </Card>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default AddEditEmployee;
